import { GetAdjusterOpinionQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/getAdjusterOpinion/getAdjusterOpinionQuery.type';
import { getAdjusterOpinionFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/getAdjusterOpinion/getAdjusterOpinionQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getAdjusterOpinionQueryOptions = ({
  id,
  onSuccess,
}: GetAdjusterOpinionQueryParamsType) => {
  return queryOptions({
    queryKey: ['adjusterOpinion', id],
    queryFn: () => getAdjusterOpinionFunction({ id }),
    enabled: true,
    meta: {
      onSuccess: onSuccess,
    },
  });
};
